import { updateAuthenticationStatus } from "@mojo/analytics";
import useSWR from "swr";
import { getSession, getSessionQR } from "../../client/session";

/**
 * Returns decoded session token
 */
export const useSession = () => {
  return useSWR(
    "session",
    async () => {
      try {
        const session = await getSession();
        const sessionData = session.data;
        // Update authentication status cache whenever session data changes
        updateAuthenticationStatus(sessionData);
        return sessionData;
      } catch (err) {
        // Update authentication status cache to logged out on error
        updateAuthenticationStatus(null);
        return null;
      }
    },
    {
      // self explanatory
      shouldRetryOnError: false,
      // revalidates when window or tab is re-focused
      revalidateOnFocus: false,
      // revalidates if hook is re-rendered and the data is stale
      revalidateIfStale: false,
      // revalidate data after reconnecting to the network
      revalidateOnReconnect: false,
    },
  );
};

/**
 * Returns a base64 image of a QR code that, when scanned, shares the user's session to the device that scanned it
 */
export const useSessionQR = () => {
  return useSWR(
    "session-qr",
    async () => {
      try {
        const sessionQr = await getSessionQR();
        return sessionQr.data;
      } catch (err) {
        return null;
      }
    },
    {
      // self explanatory
      shouldRetryOnError: false,
      // revalidates when window or tab is re-focused
      revalidateOnFocus: false,
      // revalidates if hook is re-rendered and the data is stale
      revalidateIfStale: false,
      // revalidate data after reconnecting to the network
      revalidateOnReconnect: false,
    },
  );
};
